import React from 'react';
import classNames from 'classnames';
import EfLink from '@elem/ui/ef-link';
import styles from './index.module.scss';
interface NextGenInfoProps {
    className?: string;
    /** 标题 */
    title?: string;
    /** 基础信息 */
    infoList: {
        title: string;
        desc: string;
    }[];

    /** buy now */
    buyNowItem?: {
        href?: string;
        text?: string;
    };
}

const NextGenInfo: React.FC<NextGenInfoProps> = ({ className, title, infoList, buyNowItem }) => {
    return (
        <div className={classNames('ef-NextGen-info', className, styles.TheComp)}>
            {title && <div className="ef-NextGen-info-title">{title}</div>}
            <div className="ef-NextGen-info-divider" />
            <div className="ef-NextGen-info-list">
                {infoList.map((item) => (
                    <div className="ef-NextGen-info-item" key={item.title}>
                        <div className="ef-NextGen-info-item-title">{item.title}</div>
                        <div className="ef-NextGen-info-item-desc">{item.desc}</div>
                    </div>
                ))}
            </div>
            <div className="ef-NextGen-info-alert-btns">
                {buyNowItem && (
                    <EfLink
                        className="ef-NextGen-info-buyNow btn"
                        dataLayer={{
                            event: 'uaEvent',
                            event_name: 'buy',
                            product_name: buyNowItem.text ?? 'Buy Now',
                            position: 'Product Detail',
                        }}
                        href={buyNowItem.href}
                    >
                        {buyNowItem.text ?? 'Buy Now'}
                    </EfLink>
                )}
            </div>
        </div>
    );
};
export default NextGenInfo;
